import createReactComponent from '../createReactComponent';
export default createReactComponent('x', 'X', [["path",{"d":"M18 6 6 18M6 6l12 12","key":"svg-0"}]]);